import React from "react";
import * as Icon from "react-bootstrap-icons";
import "./LoadingSpinner.css";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  text?: string;
  fullScreen?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "md",
  text = "Loading...",
  fullScreen = false,
}) => {
  const sizeClasses = {
    sm: "loading-spinner-sm",
    md: "loading-spinner-md",
    lg: "loading-spinner-lg",
  };

  const iconSizes = {
    sm: 24,
    md: 40,
    lg: 56,
  };

  const content = (
    <div
      className={`loading-spinner-container ${
        fullScreen ? "loading-spinner-fullscreen" : ""
      }`}
    >
      <div className={`loading-spinner ${sizeClasses[size]}`}>
        <div className="loading-spinner-icon">
          <Icon.HouseFill size={iconSizes[size]} />
        </div>
        <div className="loading-spinner-pulse"></div>
      </div>
      {text && <div className="loading-spinner-text">{text}</div>}
    </div>
  );

  return content;
};

export default LoadingSpinner;
